import React, { useMemo } from "react";
import { useToast } from "../../../Store/modules/toast/toast";
import { createPortal } from "react-dom";
import { Div, Icon, Text } from "../../Kit";
import { GlobalRefresh } from "iconsax-react";
import settings from "../../../settings/settings";
import { useLanguage } from "../../../Store/modules/language";
import { useTranslation } from "react-i18next";

export const NoInternetToast: React.FC = () => {
  const { name } = useToast();
  const isOpen = useMemo(() => name === "NoInternet", [name]);
  const { direction } = useLanguage();
  const { t } = useTranslation();
  return isOpen
    ? createPortal(
        <Div
          bg="error"
          className="absolute top-[8%] left-[50%] translate-x-[-50%] xs:w-[80%] md:w-auto rounded-[5px] px-[16px] py-[12px] flex items-center justify-between min-w-0"
          dir={direction}
        >
          <Text elementType="div" color="white" lineHeight="27px" translatable={false}>
            <p className="text-center">
              <Icon Component={GlobalRefresh} size={20} color="white" className="inline me-1" />
              {
                //@ts-ignore
                t("noInternet")
              }
              <img
                src={settings.progressLoading.light}
                alt="progress-loading"
                className="w-[14px] inline ms-1 mt-1"
              />
            </p>
          </Text>
        </Div>,
        document.body,
      )
    : null;
};
